export default __webpack_public_path__ + "static/partnerColorIcon7-0782308d699a08bb344468d63738eeac.svg";